import { render, staticRenderFns } from "./Theme4Sections.vue?vue&type=template&id=0d635396&scoped=true&"
import script from "./Theme4Sections.vue?vue&type=script&lang=js&"
export * from "./Theme4Sections.vue?vue&type=script&lang=js&"
import style0 from "./Theme4Sections.vue?vue&type=style&index=0&id=0d635396&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d635396",
  null
  
)

export default component.exports